import { ReactNode, createContext, useState } from "react";
import { Work } from "@models/work";

interface WorkContextType {
  work: Work | null;
  setWork: (work: Work) => void;
}

export const WorkContext = createContext<WorkContextType>({
  work: null,
  setWork: () => {},
});

export const WorkProvider: React.FC<{ children: ReactNode; work: Work }> = ({ children, work }) => {
  const [currentWork, setCurrentWork] = useState<Work>(work);

  return (
    <WorkContext.Provider value={{ work: currentWork, setWork: setCurrentWork }}>
      {children}
    </WorkContext.Provider>
  );
};
